function FilterNews ($el) {
  this.$el = $el.getAttribute('data-vanilla');
  try {
    this.categories = JSON.parse($el.getAttribute('data-categories') || '[]');
    this.categoriesForm = $el.querySelectorAll('form');
  } catch (err) {
    console.error(err);
  }

  const categories = this.categories;

  $el.addEventListener('click', function () {
    Modal.open('FORM_FILTER', {
      title: 'Busca noticias...',
      inputs: {
        category: {
          title: 'Categoria',
          type: 'select',
          options: (function () {
            const arr = [];
            categories.forEach((a) => {
              arr.push(`${a}:${a}`);
            });
            return arr;
          })(),
          defaultValue: ''
        }
      },
      onSubmit: function (dados) {
        if (dados.category) {
          window.location = `/noticias/${dados.category}`;
        }
      }
    });
  });
}

(function () {
  const els = document.querySelectorAll('[data-vanilla="FilterNews"]');
  if (els.length) {
    for (const $el of els) {
      new FilterNews($el);
    }
  }
})();
